import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <div className="bg-background/90 rounded-2xl p-4 inline-flex items-center justify-center">
              <picture>
                <source srcSet="/LKNTechLogo.webp" type="image/webp" />
                <img src="/LKNTechLogo.png" alt="Lake Norman Technologies" className="h-32 w-auto" width={128} height={128} loading="lazy" decoding="async" />
              </picture>
            </div>
            <p className="text-primary-foreground/70 text-sm leading-relaxed">
              AI-assisted web & app development at affordable prices. Proudly serving businesses from Mooresville, NC.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif font-bold mb-4 text-base">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About" },
                { to: "/services", label: "Services" },
                { to: "/pricing", label: "Pricing" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-primary-foreground/70 hover:text-accent transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Serving Locations */}
          <div>
            <h3 className="font-serif font-bold mb-4 text-base">Serving</h3>
            <ul className="space-y-2 text-sm">
              {[
                { to: "/locations/mooresville", label: "Mooresville, NC" },
                { to: "/locations/cornelius", label: "Cornelius, NC" },
                { to: "/locations/davidson", label: "Davidson, NC" },
                { to: "/locations/huntersville", label: "Huntersville, NC" },
                { to: "/locations/charlotte", label: "Charlotte, NC" },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-primary-foreground/70 hover:text-accent transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-serif font-bold mb-4 text-base">Contact Us</h3>
            <ul className="space-y-3 text-sm text-primary-foreground/70">
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-accent" />
                Mooresville, North Carolina
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-accent" />
                info@lkntechnologies.com
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-accent" />
                (704) 360-0770
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/10 mt-8 pt-6 text-center text-sm text-primary-foreground/80">
          © {new Date().getFullYear()} Lake Norman Technologies. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
